import { SubscriptionTag as SubscriptionTagModel } from '@models/membership/SubscriptionTag'
import { useAppSelector } from '@store/hooks'
import { selectSubscriptionTagById } from '@store/membership/SubscriptionTagReducer'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { Tag } from 'antd'
import { AvatarProps } from 'antd/es/avatar'
import { FC } from 'react'

type Props = SBModelComponent<SubscriptionTagModel> & {
  size?: AvatarProps['size']
}

const SubscriptionTagAvatar: FC<Props> = ({ id, model }) => {
  const item = model ? model : useAppSelector(selectSubscriptionTagById(id!))

  if (!item) {
    return <></>
  }
  return <Tag color={item.color}>{item.name}</Tag>
}

type SubscriptionTagAvatarType = {
  Avatar: typeof SubscriptionTagAvatar
}

export { SubscriptionTagAvatar, type SubscriptionTagAvatarType }
